import { FC, useMemo, useState } from 'react';

import cn from 'clsx';

import Modal from 'react-modal';
import { format, setHours, setMinutes } from 'date-fns';
import ButtonMighty from '@components/elements/ButtonMighty';
import React from 'react';

interface DatePickerModalProps {
  onSelect?: (value: Date) => void;
  title?: string;
  value?: Date;
  open?: boolean;
  onClose?: () => void;
  dateFormat?: string;
}

const MODAL_STYLE = {
  content: {
    padding: 0,
    top: '50%',
    left: 'calc(50% - 8px)',
    transform: 'translate(-50%, -50%)',
    height: '500px',
    maxHeight: '80%',
    width: 'calc(100% - 48px)',
    overflow: 'hidden',
    borderRadius: '5px',
    border: '3px solid #ff1dfc',
    boxShadow: '6px 4px 0px 0px #8052ff',
  },
};

const HOURS = Array.from({ length: 12 }, (_, i) => {
  return i + 1;
});

const MINUTES = Array.from({ length: 60 }, (_, i) => {
  return i;
});

const DatePickerModal: FC<DatePickerModalProps> = ({
  onSelect,
  title,
  open = false,
  value: propValue,
  onClose,
  dateFormat,
}) => {
  const [date, setDate] = useState<Date>(propValue || new Date());

  const hourRefs = useMemo(
    () =>
      Array(12)
        .fill(0)
        .map(() => React.createRef<HTMLLIElement>()),
    []
  );
  const minuteRefs = useMemo(
    () =>
      Array(60)
        .fill(0)
        .map(() => React.createRef<HTMLLIElement>()),
    []
  );

  // useEffect(() => {
  //   hourRefs[hour - 1].current?.scrollIntoView({
  //     behavior: 'smooth',
  //     block: 'start',
  //   });
  // }, [hour]);

  // useEffect(() => {
  //   minuteRefs[minute].current?.scrollIntoView({
  //     behavior: 'smooth',
  //     block: 'start',
  //   });
  // }, [minute]);

  const _onSelect = () => {
    console.log({ select: date });
    onSelect?.(date);
  };

  const itemCn = cn(
    'cursor-pointer py-2 text-lg text-gray-500 hover:bg-gray-50 hover:underline px-4 font-display select-none'
  );
  const itemActiveCn = 'bg-magenta text-gray-900 hover:bg-magenta';
  const colCn = cn('flex-1 text-center overflow-y-auto h-full pb-64');

  return (
    <Modal
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-10"
      style={MODAL_STYLE}
      isOpen={open}
      onRequestClose={onClose}
    >
      <div className="flex justify-between py-4 mx-4">
        <h2 className="text-lg">
          {title || `Select time - ${format(date, 'h:mm a')}`}
        </h2>
        <button className="underline" onClick={onClose}>
          Close
        </button>
      </div>

      <div className="flex h-full">
        <ul className={colCn}>
          {HOURS.map((value, index) => {
            return (
              <li
                ref={hourRefs[index]}
                key={`time-hour-${value}`}
                className={cn(itemCn, {
                  [itemActiveCn]: date.getHours() % 12 === value % 12,
                })}
                onClick={() => {
                  const hour = value % 12;
                  setDate(
                    setHours(date, date.getHours() >= 12 ? hour + 12 : hour)
                  );
                }}
              >
                {value}
              </li>
            );
          })}
        </ul>
        <ul className={colCn}>
          {MINUTES.map((value, index) => {
            return (
              <li
                ref={minuteRefs[index]}
                key={`time-minute-${value}`}
                className={cn(itemCn, {
                  [itemActiveCn]: date.getMinutes() === value,
                })}
                onClick={() => {
                  setDate(setMinutes(date, value));
                }}
              >
                {value}
              </li>
            );
          })}
        </ul>
        <ul className={colCn}>
          <li
            className={cn(itemCn, {
              [itemActiveCn]: date.getHours() < 12,
            })}
            onClick={
              date.getHours() >= 12
                ? () => {
                    setDate(setHours(date, date.getHours() - 12));
                  }
                : undefined
            }
          >
            AM
          </li>
          <li
            className={cn(itemCn, {
              [itemActiveCn]: date.getHours() >= 12,
            })}
            onClick={
              date.getHours() < 12
                ? () => {
                    setDate(setHours(date, date.getHours() + 12));
                  }
                : undefined
            }
          >
            PM
          </li>
        </ul>
      </div>

      <div className="absolute bottom-0 left-0 right-0 py-8 bg-gradient-to-t from-gray-light to-transparent">
        <ButtonMighty
          color="#4400FF"
          text="Set time"
          borderColor="#ff1dfc"
          margin="0"
          textColor="#fff"
          onClick={_onSelect}
        />
      </div>
    </Modal>
  );
};

export default DatePickerModal;
